import {baseBackendUrl} from "../shared/constants";

export async function loadDashboard(){
    const token = localStorage.getItem('token');
    const response = await fetch(`${baseBackendUrl}/dashboard`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
    if (!response.ok) {
        throw new Error('Ошибка при загрузке данных дашборда');
    }
    const data = await response.json();
    return data;
}